import React , { useState } from 'react';
import './App.css';
import WebSocketComponent from './WebSocketComponent';
import PageResult from './components/pageResult';
import PageMining from './components/pageMining';

import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

export default function App() {
  return (
    <Router>
      <div className="h-screen w-full bg-[#0a0a0c] text-white font-sans overflow-hidden flex flex-col">
        
        {/* Navigation */}
        <nav className="flex items-center justify-between px-6 py-4 border-b border-gray-800 bg-[#0d0d0f] shrink-0">
          <h1 className="text-xl font-black tracking-tighter text-blue-500">
            MINING <span className="text-gray-500">PRO</span>
          </h1>
          
          <div className="flex gap-4">
            {/* On remplace les boutons par des Link */}
            <Link to="/" className="px-4 py-2 text-sm text-gray-400 hover:text-white">Live</Link>
            <Link to="/mine" className="px-4 py-2 text-xs font-bold text-blue-400 hover:text-blue-300 transition-colors">
              NOUVELLE SESSION
            </Link>
            <Link to="/results" className="px-6 py-2 bg-blue-600 hover:bg-blue-500 text-white text-sm font-bold rounded-full transition-all">
              Voir Résultats
            </Link>
          </div>
        </nav>

        {/* Le contenu qui change selon l'URL */}
        <main className="flex-1 overflow-hidden relative min-h-0">
          <Routes>
            <Route path="/" element={<WebSocketComponent />} />
            <Route path="/mine" element={<PageMining />} />
            <Route path="/results" element={<PageResult />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}